<template>
  <div class="light-box">
    <div class="main-img-container">
        <div class="main-img">
            <img :src="getPathImg(currentIndex)" @error="imageIntrouvable($event)" />
        </div>
    </div>
    <div class="image-slider">
        <div class="light-box-item-nav" v-if="lastShownIndex > 2">
            <img src="../../assets/img/general/arrow-right.png" @click="switchImage('previous')" @error="imageIntrouvable($event)" />
        </div>
        <div class="light-box-thumbnails">
            <ul>
                <li class="light-box-item" v-for="(uneImage, index) in imagesShown" :key="index" @click="selectImage(uneImage.nIndex)">
                    <div class="light-box-item-img"><img :src="getPathImg(uneImage.nIndex)" @error="imageIntrouvable($event)" />
                    </div>
                </li>
            </ul>
        </div>
        <div class="light-box-item-nav" v-if="lastShownIndex < (images.length - 3)">
            <img src="../../assets/img/general/arrow-right.png" @click="switchImage('next')" @error="imageIntrouvable($event)" />
        </div>
    </div>
  </div>
</template>

<script>
export default {

    // TODO : Passer le tableau d'images en tant que props.
    props: ['aImage', 'fImageIntrouvable'],
    data() {
        return {

            // L'index de la photo affichée.
            currentIndex: 0,

            // Le dernier index de vignette affiché.
            lastShownIndex: 2,

            // Toutes les vignettes.
            images: []
        };
    },
    methods: {

        imageIntrouvable(event) {
            if (this.$props.fImageIntrouvable) {
                this.$props.fImageIntrouvable(event);
            }
            // if(event.target.src === event.target.src.replace(/p1-/g, 'P1-')) {
            //    event.target.src = "https://fakeimg.pl/200x200/?text=Produit" 
            // } else {
            //     event.target.src = event.target.src.replace(/p1-/g, 'P1-');
            // }
        },

        /**
         * Navigation dans les vignettes vers la 
         * gauche ou la droite.
         * @param  {string} sType Dans les précédentes ou suivantes (previous | next).
         * @return {void}
         */
        switchImage(sType) {
            // Selon si on avance ou recule, on incrémente 
            // ou décrémente le compteur de la dernière vignette affichée.
            // (utilisé dans imagesShown pour savoir quelles images afficher)
            if (sType == 'previous' && this.lastShownIndex > 2) {
                this.lastShownIndex--;
            } else if (sType == 'next' && this.lastShownIndex < (this.images.length - 3)) {
                this.lastShownIndex++;
            }
        },

        /**
         * Au clic sur une vignette, on stocke 
         * l'index de l'image.
         * @param  {integer} nIndex Index de l'image cliquée.
         * @return {void}
         */
        selectImage(nIndex) {
            this.currentIndex = nIndex;
        },

        /**
         * Renvoie l'image en fonction de son index
         * @param  {integer} nIndex Index de l'image voulue.
         * @return {object}         Image voulue.
         */
        getPathImg(nIndex) {
            return this.$props.aImage[nIndex];
        }

    },
    computed: {

        /**
         * Renvoie les x images à afficher en tant 
         * que vignettes.
         * @return {array} Images à afficher.
         */
        imagesShown() {
            // On part de l'index de la dernière vignette affichée 
            // auquel on soustrait le nombre de vignettes affichées 
            // moins un.
            // Cela nous permet de sélectionner les prochaines vignettes 
            // à afficher.
            let imagesShown = [];
            for (var i = (this.lastShownIndex - 2); i <= this.lastShownIndex; i++) {
                imagesShown.push({
                    nIndex: i,
                    image: this.$props.aImage[i]
                });
            }
            return imagesShown;
        }

    },
    created() {

        // Lors de la création du composant 
        // on sélectionne la première image.
        this.selectImage(this.currentIndex);

    }
}
</script>

<style scoped>
    .light-box {
        max-width: 400px;
        margin: auto;
    }
    .light-box .main-img-container {
        padding: 10px 10px 20px;
        position: relative
    }

    .light-box .main-img {
        border: solid 1px #E9E9E9;
    }
    .image-slider {
        display: flex;
        align-items: center;
    }
    .light-box-thumbnails {
        display: inline-block;
        position:relative;
    }
    ul {
        list-style-type: none;
        display: inline-block;
    }
    ul li {
        display: inline-block;
        width: calc(100% / 3);
        padding: 0px 10px;
    }
    .image-slider ul li .light-box-item-img {
        border: solid 1px #E9E9E9;
        position: relative;
    }

    .light-box-item-nav {
        display: inline-block;
    }
/* 
    .light-box-thumbnails {
        width: calc(100% - 30px);
    } */
</style>